"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsCreateLookalikeAudience = exports.facebookAdsCreateLookalikeAudienceResultSchema = exports.facebookAdsCreateLookalikeAudienceArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsCreateLookalikeAudienceArgsSchema = zod_1.z.object({
    name: zod_1.z.string().describe('Lookalike audience name'),
    originAudienceId: zod_1.z
        .string()
        .describe('Source Custom Audience ID (must have 100+ people). Use facebookAdsListAudiences to get valid audience IDs before creating lookalikes.'),
    targetCountry: zod_1.z
        .string()
        .describe('Target country code in ISO 3166-1 alpha-2 format (e.g., US, CA, GB)'),
    ratio: zod_1.z
        .number()
        .min(0.01)
        .max(0.2)
        .describe('Lookalike percentage as decimal (0.01 = 1%, 0.05 = 5%, 0.10 = 10%, max 0.20 = 20%). Use 0.01-0.02 for quality, 0.05-0.10 for reach.'),
    startingRatio: zod_1.z
        .number()
        .min(0.01)
        .max(0.2)
        .nullable()
        .optional()
        .describe('For ranged lookalikes: starting percentage (e.g., 0.01 for 1%-5% lookalike)'),
    emitMode: zod_1.z.literal('single'),
});
exports.facebookAdsCreateLookalikeAudienceResultSchema = zod_1.z.object({
    id: zod_1.z.string().describe('Created lookalike audience ID'),
    name: zod_1.z.string().describe('Audience name'),
    delivery_status: zod_1.z
        .object({
        code: zod_1.z.number(),
        description: zod_1.z.string(),
    })
        .describe('441 = populating (30-60 min), 200 = ready, 430+ = failed'),
    lookalike_spec: zod_1.z.object({
        type: zod_1.z.string(),
        country: zod_1.z.string(),
        ratio: zod_1.z.number(),
    }),
});
exports.facebookAdsCreateLookalikeAudience = (0, common_1.createToolMetadata)({
    id: 'facebookAdsCreateLookalikeAudience',
    displayName: 'Create Meta Lookalike Audience',
    displayDescription: 'Create a Lookalike Audience to find people similar to your best customers',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsCreateLookalikeAudienceArgsSchema,
}, exports.facebookAdsCreateLookalikeAudienceResultSchema);
